import React, { useState } from 'react';
import * as styles from './index.module.scss';
import { Col } from 'antd';
import { StaticImage } from 'gatsby-plugin-image';
import { motion } from 'framer-motion';
import AnimationButton from '../../../../../components/animationButton';
import classNames from 'classnames';
interface ColItem {
  label: string;
  img: string;
  desc: string | TrustedHTML;
  coming: boolean;
  link?: string;
}
const ColItem = ({ label, img, desc, coming, link }: ColItem) => {
  const [isHover, setIsHover] = useState<boolean>(false);

  const clickButton = () => {
    if (!link) return;
    window.open(link);
  };
  return (
    <Col
      className={styles.item}
      xl={{ flex: '33%' }}
      lg={{ flex: '100%' }}
      sm={{ flex: '100%' }}
      xs={{ flex: '100%' }}
    >
      <motion.div
        className={styles.content}
        onHoverStart={() => setIsHover(true)}
        onHoverEnd={() => setIsHover(false)}
      >
        <div className={styles.label}>
          <img className={styles.icon} src={img} alt={label} />
          <div>
            {label}
            {/* {coming && <label>Coming Soon</label>} */}
          </div>
        </div>
        <div
          className={styles.inner}
          dangerouslySetInnerHTML={{ __html: desc }}
        ></div>
        {coming ? (
          <div className={styles.coming}>Coming Soon</div>
        ) : (
          <AnimationButton
            className={classNames(
              styles.itemButton,
              isHover && styles.buttonHoverColor
            )}
            onClick={clickButton}
            playAnimation={isHover}
            iconStart="75px"
            iconEnd="90px"
          >
            Learn More
          </AnimationButton>
        )}
      </motion.div>
    </Col>
  );
};

export default ColItem;
